import React from 'react';

interface TableCellButtonProps {
  value: string;
  onClickHandler: any;
  rowIndex?: number;
  tabIndex: number;
}

/**
 * Komponente für jede einzelene Zelle einer {@link Table.jsx}
 *
 * @param name - Html Name des Elementes
 * @param value Html Value des Elementes
 * @param onClickHandler  on click handler
 * @param rowIndex Zeilenindex
 * @param tabIndex tab index (auch -1 or 0), definiert die Tabreihenfolge
 * @returns {JSX.Element}
 * @constructor
 */
const TableCellButton = ({
  value,
  onClickHandler,
  rowIndex,
  tabIndex = 0,
}: TableCellButtonProps) => {
  /**
   * OnClick-Handler.
   * Definiert die Aktion, die ausgeführt wird, wenn das Element angeklickt wurde.
   */
  const onClick = () => {
    onClickHandler(rowIndex);
  };

  return (
    <div
      className={value && value !== '' ? 'table-cell-button' : ''}
      onClick={onClick}
      tabIndex={tabIndex}
    >
      {value}
    </div>
  );
};

export default TableCellButton;
